// Module
var code = "<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"getSchema()\" ng-disabled=\"loadingSchema\">\n  <i class=\"fa fa-refresh fa-spin fa-fw\" ng-if=\"loadingSchema\"></i> {{ 'data-preview.title' | translate }}\n</button>\n";
// Exports
module.exports = code;